const state = {
  preferences: {}
};

export const getters = {
  valuePreference : state => key => state.preferences[key],
  showFirstNameAndLastName : state => state.preferences ? `${state.preferences.firstName} ${state.preferences.lastName}` : 'Utilisateur inconnu'
};

const mutations = {
  setPreference(state, { key, value }) {
    state.preferences[key] = value;
  },
  setUserPreferenceInstance(state, userPreference) {
    state.preferences = userPreference;
  }
};

export const actions = {
  savePreference({ commit }, { key, value }) {
    commit('setPreference', { key, value });
  },
  setUserPreferenceInstance({ commit }, userPreference) {
    commit('setUserPreferenceInstance', userPreference);
  }

};

// Have to be imported as 'navigation' in store.js to work with NavigationMixin
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
